// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38NX6","type":"styles_type__2DMJY","choices":"styles_choices__PxtOY"};